import { Chip, TableCell } from "@mui/material";
import { type DateTime } from "luxon";

export interface CloudZeroAssetRowData {
  orgId: string;
  orgName: string;
  status: string;
  timeCreated: DateTime;
}

export interface CloudZeroAssetRowProps {
  data: CloudZeroAssetRowData;
}

export const CloudZeroAssetRow = ({ data }: CloudZeroAssetRowProps) => (
  <>
    <TableCell data-cy={`cloud-zero-asset-orgid-${data.orgId}`}>{data.orgId}</TableCell>
    <TableCell data-cy={`cloud-zero-asset-orgname-${data.orgId}`}>{data.orgName}</TableCell>
    <TableCell data-cy={`cloud-zero-asset-timecreated-${data.orgId}`}>{data.timeCreated.toLocaleString()}</TableCell>
    <TableCell data-cy={`cloud-zero-asset-status-${data.orgId}`}>
      {data.status === "active" ? (
        <Chip size="small" label="Active" color="success" data-cy="cloud-zero-asset-status-active" />
      ) : (
        <Chip size="small" label="Inactive" color="error" data-cy="clo  d-zero-asset-status-inactive" />
      )}
    </TableCell>
  </>
);
